export var appVersion = function appVersion(_config, _data, globalConfig) {
  var pluginData = {
    'app:web:version': globalConfig.app.version.web
  };
  if (globalConfig.app.version.ssr) {
    pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
  }
  return pluginData;
};